export function getStaticUrl() {
    return (window as any).SITE_CONFIG.baseUrl + (window as any).SITE_CONFIG.staticUrl;
    // return "localhost:3000/assets";
}

export function delayFunction(func: any, delay: number) {
    let interval: any = null;
    const wrapper = () => {
        func();
        clearInterval(interval);
    };

    interval = setInterval(wrapper, delay);
}

export function parseErrorInMessage(error) {
    return error;
}



// WEBPACK FOOTER //
// ./src/core/utils/object.ts